// extracted by mini-css-extract-plugin
export var landingPageSubscribed = "NewsletterSignup-module--landingPageSubscribed--B9Sbs";
export var newsletterSignup = "NewsletterSignup-module--newsletter-signup--rzaY8";
export var newsletterSignupConfirmation = "NewsletterSignup-module--newsletter-signup-confirmation--e0cF1";
export var newsletterSignupInputs = "NewsletterSignup-module--newsletter-signup-inputs--YFiF4";
export var newsletterSignupSubtext = "NewsletterSignup-module--newsletter-signup-subtext--Kf3xI";
export var primary = "#06004d";
export var secondary = "#4dafd7";